import { useState, useEffect } from 'react';
import moment from 'moment';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import Settings from '@material-ui/icons/Settings';
import withStyles from '@material-ui/core/styles/withStyles';
import makeStyles from '@material-ui/styles/makeStyles';
import PowerSettings from '@material-ui/icons/PowerSettingsNew';
import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle';
import {
  drawerWidth,
  whiteColor,
} from 'assets/jss/material-dashboard-pro-react';
import adminNavbarLinksStyle from 'assets/jss/material-dashboard-pro-react/components/adminNavbarLinksStyle';
import { put, get } from 'helpers/apiHelpers';
import {
  handleBrandChange,
  refreshLogin,
  setSelectedLanguage,
} from 'actions/Auth';
// eslint-disable-next-line no-duplicate-imports -- FIXME
import { fetchLanguages } from 'actions/Auth';
import Button from 'components/CustomButtons/Button';
import SelectInput from 'components/FormSelect/SelectInput';
import { ROLE_EDIT_BRAND } from 'helpers/roles';
// eslint-disable-next-line import/order -- FIXME
import { isGranted, combineStyles } from 'helpers/helpers';

import 'moment/locale/en-gb';
import 'moment/locale/uk';
import 'moment/locale/fi';
import 'moment/locale/pl';
import 'moment/locale/ru';

import translationEN from 'locales/en.json';
import translationPL from 'locales/pl.json';
import translationLV from 'locales/lv.json';
import translationRU from 'locales/ru.json';
import { toast } from 'react-toastify';

const useStyles = makeStyles({
  container: {
    position: 'relative',
    zIndex: '4',
    width: `${drawerWidth}px`,
  },
  select: {
    color: whiteColor,
  },
  selectIcon: {
    color: whiteColor,
  },
});

const SidebarMobileLinks = ({
  user,
  brand,
  brands,
  classes: propClasses,
  history,
  languages = [],
  // eslint-disable-next-line no-shadow -- FIXME
  fetchLanguages,
  selectedLanguage,
  // eslint-disable-next-line no-shadow -- FIXME
  handleBrandChange,
  // eslint-disable-next-line no-shadow -- FIXME
  setSelectedLanguage,
  adminAllowedToChangeLanguage,
}) => {
  const classes = useStyles();
  const { t, i18n } = useTranslation();
  const [language, setLanguage] = useState(null);

  useEffect(() => {
    if (!i18n.language) {
      // eslint-disable-next-line no-use-before-define -- FIXME
      initSidebarMobileLinks();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIXME
  }, []);

  useEffect(() => {
    if (language !== i18n.language) {
      setLanguage(i18n.language);
      // eslint-disable-next-line no-use-before-define -- FIXME
      fetchLanguageBeforeChange(i18n.language);
      moment.locale(i18n.language);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIXME
  }, [language]);

  const initSidebarMobileLinks = async () => {
    try {
      await fetchLanguages();

      // eslint-disable-next-line promise/prefer-await-to-then, promise/prefer-await-to-callbacks, no-console -- FIXME
      i18n.changeLanguage(user.language).catch(error => console.error(error));
      moment.locale(user.language);
    } catch (e) {
      // eslint-disable-next-line no-console -- FIXME
      console.log({ e });
    }
  };

  const fetchLanguageBeforeChange = lang => {
    const DEFAULT_BUNDLES = {
      en: translationEN,
      pl: translationPL,
      lv: translationLV,
      ru: translationRU,
    };
    // eslint-disable-next-line no-async-promise-executor, promise/param-names -- FIXME
    return new Promise(async res => {
      const resource = i18n.getResource(lang, 'translation');

      if (typeof resource === 'undefined') {
        let startedLanguage = {};

        try {
          startedLanguage = await get(
            '/translations/loader/admin/default',
            {},
            { forcedLanguage: lang }
          );
          // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-empty -- FIXME
        } catch (e) {}
        await i18n.addResourceBundle(lang, 'translation', {
          ...(DEFAULT_BUNDLES[lang ?? i18n.language ?? 'pl'] ?? {}),
          ...startedLanguage,
        });
      }
      res(true);
    });
  };

  const saveUserLanguage = (value, languageObject) => {
    put(user.id, { language: value })
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      .then(() => {
        setSelectedLanguage(languageObject);
      })
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      .then(() => {
        toast.success(t('success.dataUpdated'));
      });
  };

  const handleLanguageChange = async (
    { target: { value } },
    languageObject
  ) => {
    await fetchLanguageBeforeChange(value);
    // eslint-disable-next-line promise/prefer-await-to-then, promise/prefer-await-to-callbacks, no-console -- FIXME
    i18n.changeLanguage(value).catch(error => console.error(error));
    moment.updateLocale(value, {
      week: {
        dow: 1,
      },
    });

    saveUserLanguage(value, languageObject);
  };

  const customSelectClasses = {
    select: classNames(propClasses.select, classes.select),
    icon: classes.selectIcon,
  };

  return (
    <div className={classes.container}>
      <div style={{ display: 'flex', margin: '0 15px' }}>
        <div
          style={
            languages && adminAllowedToChangeLanguage
              ? { width: '170px' }
              : { width: '100%', minWidth: '150px', marginLeft: '10px' }
          }
        >
          <SelectInput
            classes={propClasses}
            customSelectClasses={customSelectClasses}
            options={brands}
            mapBy="name"
            trackBy="id"
            value={brand}
            // eslint-disable-next-line no-shadow -- FIXME
            handleChange={(ev, brand) => {
              handleBrandChange(ev, { brand, refresh: true });
            }}
          />
        </div>

        {languages && adminAllowedToChangeLanguage && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              width: '80px',
            }}
          >
            <div
              style={{
                marginRight: '10px',
              }}
            >
              {selectedLanguage?.image && (
                <img
                  src={
                    process.env.REACT_APP_STATIC_FILES_CDN +
                    selectedLanguage.image.contentUrl
                  }
                  alt=""
                />
              )}
            </div>
            <SelectInput
              mapBy="isoCode"
              value={selectedLanguage}
              classes={propClasses}
              customSelectClasses={customSelectClasses}
              options={languages}
              trackBy="isoCode"
              handleChange={handleLanguageChange}
            />
          </div>
        )}
      </div>

      <div style={{ padding: '5px 15px' }}>
        {isGranted(ROLE_EDIT_BRAND) && (
          <Button
            color="transparent"
            style={{ margin: '5px 0', width: '100%' }}
            onClick={() => history.push(`/admin/brands/edit/${brand}`)}
          >
            <div style={{ width: '100%' }}>
              <Settings /> {t('common.panelSettings')}
            </div>
          </Button>
        )}

        <Button
          color="transparent"
          onClick={() => history.push('/auth/login')}
          style={{ margin: '5px 0', width: '100%' }}
        >
          <PowerSettings /> {t('brandCfg.logout')}
        </Button>
      </div>
    </div>
  );
};

const combinedStyles = combineStyles(extendedFormsStyle, adminNavbarLinksStyle);

const mapStateToProps = state => ({
  brands: state.Auth.user.brands,
  brand: state.Auth.selectedBrand,
  user: state.Auth.user,
  adminAllowedToChangeLanguage:
    state.Brands.brand.multinational.adminAllowedToChangeLanguage,
  languages: state.Auth.languages?.filter(lang => lang.enabledForAdmin) || [],
  selectedLanguage: state.Auth.selectedLanguage,
});

const mapDispatchToProps = {
  handleBrandChange,
  refreshLogin,
  fetchLanguages,
  setSelectedLanguage,
};

const enhance = compose(
  withStyles(combinedStyles),
  connect(mapStateToProps, mapDispatchToProps),
  withRouter
);

export default enhance(SidebarMobileLinks);
